import clsx from 'clsx';

import { Card, type CardProps } from '../Card';

import { Header } from './Header';

import s from './Group.module.css';

export type GroupProps = CardProps;

export const Group = ({ children, className, title, ...props }: GroupProps) => (
  <Card className={clsx(s.group, className)} {...props}>
    {children}
  </Card>
);

Group.Header = Header;
